import { useState } from "react";
import NavbarSmall from "./components/NavbarSmall";
import NavbarWide from "./components/NavbarWide";
import NavProfile from "./components/NavProfile";
import HamburgerMenuContext from "./context/hamburgerMenuContext";
import style from "./menu.module.css";

function Menu() {
  const [hambergerMenu, setHambergerMenu] = useState(false);

  return (
    <header className={"py-1 d-flex " + style.header}>
      <HamburgerMenuContext.Provider
        value={{ hambergerMenu, setHambergerMenu }}
      >
        <NavbarWide />

        <NavbarSmall />

        <NavProfile />
      </HamburgerMenuContext.Provider>
    </header>
  );
}

export default Menu;
